import domReady from '@wordpress/dom-ready';

const ROCKY_ROAD_TO_ROOT_SELECTOR = '[data-rocky-road-to-root]';

domReady(() => {
  document.querySelectorAll(ROCKY_ROAD_TO_ROOT_SELECTOR).forEach((node) => {
    node.classList.add('rocky-road-to-root--hydrated');
  });

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log('Rocky Road To front-end bootstrap ready.');
  }
});
